export { useGetCommunicationAPI } from './useGetCommunicationAPI';
export { reducerGetCommunicationAPI } from './reducerGetCommunicationAPI';
